export default {
    props: {
        errors: {
            type: Object,
            default: () => ({})
        },
        item: {
            type: Object
        },
        formValues: {
            type: Object
        }
    },
    computed: {
        isInvalid() {
            return this.errors[this.item.data.uniqlabel] !== undefined;
        },
        errorMessage() {
            if (Object.keys(this.errors).length === 0) {
                return ''
            }
            return this.errors[this.item.data.uniqlabel]
        }
    },
};